import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { shareReplay, tap } from "rxjs";
import { UpdatePassword } from "src/app/main/pages/settings/change-password/update-password.form";
import { environment } from "../environments/environment";
import { User } from "../models/models";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService<User, User> {
  apiUrl = environment.apiUrl;
  
  constructor(protected override http: HttpClient) {
    super(http, 'user');
    // Ensure apiUrl ends with a trailing slash
    if (this.apiUrl && !this.apiUrl.endsWith('/')) {
      this.apiUrl = this.apiUrl + '/';
    }
  }

  updatePassword(updatePassword: UpdatePassword) {
    return this.http.post<any>(`${this.apiUrl}user/updatePassword`, updatePassword)
      .pipe(shareReplay());
  }

  updateUser(user:any) {
    const url = `${this.apiUrl}users`;
    return this.http.patch<any>(url, {user}).pipe(shareReplay());
  }

  getUser() {
    const user = localStorage.getItem('profile');
    //if user exists in local storage, return as Observable<User>
    //if(user) return of(JSON.parse(user) as User)
    //otherwise get it from the server super.get('/profile') and save it to local storage
    return this.get('/profile').pipe(tap((user:User) => {
      localStorage.setItem('profile', JSON.stringify(user));
    }));
  }
}
